import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "./auth/AuthProvider.jsx";
import { initializeMsal } from "./auth/msalConfig.js";
import App from "./App.jsx";
import Presenter, { readPresentHash } from "./meetings/Presenter.jsx";

async function bootstrap() {
  const msalInstance = await initializeMsal();
  // The presenter pop-out (#present=<meetingId>) renders a stripped root with no app shell,
  // so a screen-shared window can't reach the rest of the Ops Hub.
  const presentId = readPresentHash();

  ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
      <AuthProvider msalInstance={msalInstance}>
        {presentId ? <Presenter meetingId={presentId} /> : <App />}
      </AuthProvider>
    </React.StrictMode>
  );
}

bootstrap().catch(console.error);
